import React from "react";
import AdmMOUList from "../../components/AdminTabs/AdminMOU/AdmMOUList";

const MOU = () => {
  return (
    <div>
      <AdmMOUList />
    </div>
  );
};

export default MOU;
